import Backbone from 'backbone'
import _ from 'lodash'
import calendars from 'scoreboard/components/calendars'

const ChartDesignerSeriePeriod = Backbone.Model.extend({
	/**
	 * Resolves this serie period to an actual calendar period ID.
	 *
	 * @param {Int} currentPeriodId - the "current" calendar period to use for
	 * relative periods (usually globals.periodId)
	 *
	 * @param {ChartDesignerRange} range - the range this period is associated
	 * with (used for determining the group calendar)
	 *
	 * @returns {Int} the resolved calendar period id
	 */
	resolvedPeriodId: function ({ currentPeriodId, range }) {
		if (!_.isNil(this.get('periodId'))) {
			// If an absolute period was defined, just return it
			return this.get('periodId')
		} else {
			// If using a relative period, first find the current period in
			// the group calendar
			let referencePeriod = calendars.correspondingPeriod(
				range.get('groupCalendarId'), currentPeriodId)

			// Then resolve the relative period
			let period = calendars.relativePeriod(referencePeriod.id,
				this.get('periodDelta'))

			return _.get(period, 'id')
		}
	}
})

export default ChartDesignerSeriePeriod

ChartDesignerSeriePeriod.__filename__ = 'charts/model/chart-designer-serie-period.js'
